import { createSlice } from "@reduxjs/toolkit";

const sysSettingSlice = createSlice({
    name: 'syssetting',
    initialState: {
        data: [],
        action: {
            isLoading: false,
            isError: false,
            errorMessage: ''
        },

        isLoading: false,
        isError: false,
        errorMessage: ''
    },
    reducers: {
        setData: (state, action) => {
            state.data = action.payload;
        },
        fetchingData: (state) => {
            state.isLoading = true;
            state.isError = false;
        },
        fetchDataSuccess: (state, action) => {
            state.isLoading = false;
            state.isError = false;

            action.payload?.data && (state.data = action.payload.data);
            action.payload?.total_items && (state.totalRows = action.payload.total_items);
        },
        fetchDataFail: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errorMessage = action.payload;
        },
        submittingData: (state) => {
            state.action.isLoading = true;
            state.action.isError = false;
        },
        submitDataSuccess: (state) => {
            state.action.isLoading = false;
            state.action.isError = false;
        },
        submitDataFail: (state, action) => {
            state.action.isLoading = false;
            state.action.isError = true;
            state.action.errorMessage = action.payload;
        },
    }
});

export const {
    setData,
    fetchingData,
    fetchDataSuccess,
    fetchDataFail,
    submittingData,
    submitDataFail,
    submitDataSuccess,
    
} = sysSettingSlice.actions;

export default sysSettingSlice.reducer;